export default __webpack_public_path__ + "static/media/Luis_llerena.7b5f40b7.jpeg";